module.exports = __webpack_public_path__ + "/img/SOT223-Labeled-dluSzo.svg";